module.exports = __webpack_public_path__ + "img/bg15.2be8baa9.png";